module.exports = __webpack_public_path__ + "static/media/19_portrait.a4d1e631.jpg";